/**
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 *  PODZIAŁ KOLUMN: CO NA EKRAN, CO DO EKSPORTU.
 *
 *  ⚠️⚠️ POWSTAŁO ZE ZGŁOSZENIA 09.09.2026: „dodaj w eksporcie pracowników, żeby był też numer
 *  karty i centrum kosztowe (w tej chwili tego brakuje)". Te dwie rzeczy są na ekranie od dawna,
 *  ale w DRUGIM WIERSZU komórki z nazwiskiem („nr 0001 · alias · CK 666"), a eksport bierze
 *  z kolumny JEDNĄ wartość (`exportValue`) — więc oddawał samo nazwisko i cicho gubił resztę.
 *
 *  ⚠️⚠️ OSOBNY MODUŁ Z TESTEM, A NIE `filter` W ŚRODKU KOMPONENTU. Ta reguła rozstrzyga o dwóch
 *  rzeczach naraz i pomyłka w każdą stronę jest cicha: kolumna „tylko do eksportu" przepuszczona
 *  do tabeli rysuje pusty słupek z nagłówkiem, a odsiana z eksportu gubi dane, po które ktoś
 *  ten eksport zrobił. Jedno i drugie widać dopiero na ekranie albo w arkuszu u klienta.
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 */

/** Tyle, ile z definicji kolumny potrzebuje ta reguła — bez wiązania się z `ColumnDef`. */
export type KolumnaDoPodzialu = {
  meta?: { exportOnly?: boolean; exportValue?: unknown };
};

/**
 * ⚠️ `exportOnly` DOMYŚLNIE FAŁSZ: kolumna bez tej flagi jest zwykłą kolumną ekranu. Odwrotne
 * domyślne ukryłoby całą tabelę każdemu, kto tej flagi nie zna.
 */
export function naEkran<T extends KolumnaDoPodzialu>(kolumny: readonly T[]): T[] {
  return kolumny.filter((c) => c.meta?.exportOnly !== true);
}

/**
 * ⚠️⚠️ DO EKSPORTU IDZIE KAŻDA KOLUMNA Z `exportValue` — TAKŻE TA UKRYTA. Filtrowanie tu po
 * `exportOnly` (albo pominięcie ukrytych) znaczyłoby, że kolumna dodana WYŁĄCZNIE dla eksportu
 * nie trafia do eksportu — czyli jedyny powód jej istnienia przestaje działać.
 */
export function doEksportu<T extends KolumnaDoPodzialu>(kolumny: readonly T[]): T[] {
  return kolumny.filter((c) => c.meta?.exportValue !== undefined);
}
